import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TranslationContext from './TranslationContext';

export default function useMRFTranslation(namespace) {
    const context = useContext(TranslationContext);

    return useTranslation(namespace ?? context ?? 'translation').t;
}
